import moment from 'moment';

const DATE_FORMAT = 'YYYY-MM-DD';

export const DASHBOARD_DEFAULT_PERIOD = '7 days';
export const DASHBOARD_CUSTOM_PERIOD = 'custom';
export const DASHBOARD_PERIOD_OPTIONS = ['24 hours', DASHBOARD_DEFAULT_PERIOD, '30 days', '12 months'];

const parseDashboardDate = value => {
  if (!value) {
    return null;
  }

  const parsed = moment(value, DATE_FORMAT, true);
  return parsed.isValid() ? parsed : null;
};

export const createDashboardDateRangeByPeriod = (
  period = DASHBOARD_DEFAULT_PERIOD,
  now = moment()
) => {
  const end = moment(now);
  const start = moment(end);

  if (period === '24 hours') {
    start.subtract(24, 'hours');
  } else if (period === '7 days') {
    start.subtract(6, 'days').startOf('day');
  } else if (period === '30 days') {
    start.subtract(29, 'days').startOf('day');
  } else if (period === '12 months') {
    start.subtract(11, 'months').startOf('month');
  }

  return {
    startDate: start.format(DATE_FORMAT),
    endDate: end.format(DATE_FORMAT),
  };
};

export const getDefaultDashboardDateRange = now =>
  createDashboardDateRangeByPeriod(DASHBOARD_DEFAULT_PERIOD, now);

export const normalizeDashboardDateRange = (
  range,
  fallbackRange = getDefaultDashboardDateRange()
) => {
  const fallback = {
    startDate: fallbackRange?.startDate || '',
    endDate: fallbackRange?.endDate || '',
  };

  const parsedStartDate = parseDashboardDate(range?.startDate);
  const parsedEndDate = parseDashboardDate(range?.endDate);

  if (!parsedStartDate || !parsedEndDate) {
    return fallback;
  }

  const start = moment.min(parsedStartDate, parsedEndDate);
  const end = moment.max(parsedStartDate, parsedEndDate);

  return {
    startDate: start.format(DATE_FORMAT),
    endDate: end.format(DATE_FORMAT),
  };
};

export const getDashboardQueryDateParams = range => {
  const normalizedRange = normalizeDashboardDateRange(range);
  const startDate = moment(normalizedRange.startDate, DATE_FORMAT, true).startOf('day');
  const endDate = moment(normalizedRange.endDate, DATE_FORMAT, true).endOf('day');

  return {
    createdAtStart: startDate.toISOString(),
    createdAtEnd: endDate.toISOString(),
  };
};

export const isSameDashboardDateRange = (left, right) => {
  const normalizedLeft = normalizeDashboardDateRange(left);
  const normalizedRight = normalizeDashboardDateRange(right);

  return (
    normalizedLeft.startDate === normalizedRight.startDate &&
    normalizedLeft.endDate === normalizedRight.endDate
  );
};

export const getDashboardActivePeriod = (range, now = moment()) => {
  const normalizedRange = normalizeDashboardDateRange(range, getDefaultDashboardDateRange(now));
  const matchedPeriod = DASHBOARD_PERIOD_OPTIONS.find(period =>
    isSameDashboardDateRange(normalizedRange, createDashboardDateRangeByPeriod(period, now))
  );

  return matchedPeriod || DASHBOARD_CUSTOM_PERIOD;
};
